import { useLocalObservable } from "mobx-react-lite";
import { useMemo } from "react";
import { CreateCopyrightByUserCommand } from "@/modules/landings/protection/commands/createCopyrightByUserCommand";
import { Modal } from "antd";
import { publisherListFactory } from "@/modules/landings/protection/factory/publisherListFactory";
const loginModal = ()=>{
    const modal = Modal.success({
        title: "완료",
        content: "신고가 완료되었습니다.",
        okButtonProps: {
            style: {
                display: "none"
            }
        }
    });
    setTimeout(()=>{
        modal.destroy();
    }, 1500);
};
export const ProtectDescriptionViewModel = (param)=>{
    let { authStore , apiService  } = param;
    const submitCopyrightInquiryCommand = useMemo(()=>new CreateCopyrightByUserCommand(apiService), [
        apiService
    ]);
    const status = useLocalObservable(()=>({
            errors: [],
            initialized: false,
            initialStatus: {
                apiErrors: {}
            },
            loading: false,
            modalOpen: false,
            _publisherOptions: [],
            imageFileList: [],
            pdfFileList: [],
            initialValues: {
                type: "normal",
                title: "",
                channel: null,
                fileData: [],
                profit: "영리",
                fileImage: [],
                link: "",
                name: "",
                publisher: "",
                is_know_date: false,
                content: "",
                status: "신고됨",
                start_date: null
            }
        }));
    const actions = useLocalObservable(()=>({
            onSetPdfFile (file) {
                ;
                status.pdfFileList = [
                    ...status.pdfFileList,
                    ...file
                ];
            },
            onSetImageFile (file) {
                ;
                status.imageFileList = [
                    ...status.imageFileList,
                    ...file
                ];
            },
            async onSubmit (values, formikActions) {
                //@todo date value
                formikActions.setSubmitting(true);
                try {
                    const response = await submitCopyrightInquiryCommand.execute(values);
                    ;
                    ;
                    if (response.success) {
                        status.modalOpen = false;
                        loginModal();
                        formikActions.resetForm();
                    } else {
                        Modal.error({
                            title: "",
                            content: "오류가 발생한 것 같습니다. 새로고침 후 다시 시도해주세요."
                        });
                    }
                } catch (error) {
                    Modal.error({
                        title: error.message,
                        content: "오류가 발생한 것 같습니다. 새로고침 후 다시 시도해주세요."
                    });
                } finally{
                //팝업창
                // protectReportCompleted()
                // formikActions.setSubmitting(false)
                }
            },
            get publisherOptions () {
                //todo 추후 커맨드 생성될 예정
                status._publisherOptions = publisherListFactory();
                return status._publisherOptions;
            },
            dispose () {}
        }));
    return {
        status,
        actions
    };
};
